import { doc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from './config';

// تحديث بيانات المستخدم في Firestore
export const updateUserProfile = async (userId, userData) => {
  try {
    if (!userId) {
      throw new Error('User ID is required');
    }
    
    const userRef = doc(db, 'users', userId);
    // Use setDoc with merge option instead of updateDoc to avoid permission issues
    await setDoc(userRef, userData, { merge: true });
    return true;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

// تحديث بيانات محددة في الملف الشخصي
export const updateProfileField = async (userId, field, value) => {
  try {
    if (!userId) {
      throw new Error('User ID is required');
    }
    
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, { [field]: value }, { merge: true });
    return true;
  } catch (error) {
    console.error(`Error updating profile field ${field}:`, error);
    throw error;
  }
};

// تحديث وسائل التواصل الاجتماعي
export const updateSocialLinks = async (userId, socialLinks) => {
  try {
    if (!userId) {
      throw new Error('User ID is required');
    }
    
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, { social: socialLinks }, { merge: true });
    return true;
  } catch (error) {
    console.error('Error updating social links:', error);
    throw error;
  }
}; 